import { useLocation, useNavigate } from 'react-router-dom';

import footerBackgroundImage from '../../assets/images/footer.png';
import logoMegImage from '../../assets/images/logo-meg.png';
import logoImage from '../../assets/images/logo.png';
import { axiosInstance as axios, setAccessToken } from '../../config/axios';
import { useAuth } from '../../hooks/useAuth';

import * as S from './Footer.styles';

const Footer = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const { user, setUser } = useAuth();

	const handleLoginClick = () => {
		//TODO comprovar com funciona això i aplicar-ho a la resta de navigates de la app per assegurar que es pot navegar sempre a la pàgina anterior (afegir botó de "back" a tot arreu on faci falta?)
		navigate('/login', { state: { from: location } });
		// window.scrollTo({
		// 	top: 0,
		// 	behavior: 'smooth',
		// });
		setTimeout(() => {
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
		}, 10);
	};

	const handleLogoutClick = async () => {
		try {
			await axios.post('/api/logout');
		} catch (error) {
			console.error('Logout failed:', error);
		} finally {
			setAccessToken(null);
			setUser(null);
			localStorage.removeItem('token'); // Cleanup legacy token
		}
	};

	return (
		<S.StyledFooter $backgroundImage={footerBackgroundImage}>
			<S.FooterContent>
				<S.LogoAddressContainer>
					<S.LogosContainer>
						<S.LogoImage
							src={logoImage}
							alt="AEiG Sant Narcís Logo"
						/>
						<S.LogoImage
							src={logoMegImage}
							alt="MEG Logo"
						/>
					</S.LogosContainer>
					<S.Address>
						Carrer de Sant Gregori, 93, 9, 11 <br />
						17007 Girona
					</S.Address>
				</S.LogoAddressContainer>
				<S.AuthContainer>
					{user ? (
						<S.StyledButton onClick={handleLogoutClick}>
							Sortir
						</S.StyledButton>
					) : (
						<S.StyledButton onClick={handleLoginClick}>
							Entrar
						</S.StyledButton>
					)}
				</S.AuthContainer>
			</S.FooterContent>
		</S.StyledFooter>
	);
};

export default Footer;
